import styled from "styled-components";
import { oakBoxCss } from "@oaknational/oak-components";

const Form = styled.form`
  ${oakBoxCss}
`;
export default Form;
